/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Client investment strategy
 * @export
 */
export const ClientInvestmentProfile = {
    Fixedincome: 'FIXEDINCOME',
    Income: 'INCOME',
    Balanced: 'BALANCED',
    Growth: 'GROWTH',
    Capitalgain: 'CAPITALGAIN'
} as const;
export type ClientInvestmentProfile = typeof ClientInvestmentProfile[keyof typeof ClientInvestmentProfile];


export function instanceOfClientInvestmentProfile(value: any): boolean {
    for (const key in ClientInvestmentProfile) {
        if (Object.prototype.hasOwnProperty.call(ClientInvestmentProfile, key)) {
            if (ClientInvestmentProfile[key as keyof typeof ClientInvestmentProfile] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientInvestmentProfileFromJSON(json: any): ClientInvestmentProfile {
    return ClientInvestmentProfileFromJSONTyped(json, false);
}

export function ClientInvestmentProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientInvestmentProfile {
    return json as ClientInvestmentProfile;
}

export function ClientInvestmentProfileToJSON(value?: ClientInvestmentProfile | null): any {
    return value as any;
}

export function ClientInvestmentProfileToJSONTyped(value: any, ignoreDiscriminator: boolean): ClientInvestmentProfile {
    return value as ClientInvestmentProfile;
}

